module.exports = __webpack_public_path__ + "img/【诊改行动】大步迈进，扬“威”智造新局面！上电智联助力盖威新能源开启轻量级数字化改造项目.153bb338.jpg";